import Modal from '../../../core/components/UI/Modal'
import { FaSpinner } from 'react-icons/fa'
import { toastError } from '../../../helper'
import useOpportunitiesActions from '../../hooks/useOpportunitiesActions'

export default function ConfirmDeleteOpportunity({
  isOpen,
  onClose,
  countryId,
  opportunityId,
}) {
  const { deleteOpportunity, inProgress } = useOpportunitiesActions()

  async function handleOnConfirmDeleteOpportunity() {
    const message = await deleteOpportunity(countryId, opportunityId)
    if (message) {
      toastError(message)
      onClose()
    }
  }
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`flex w-full flex-col gap-4 border-2 border-danger-500 bg-white p-4 lg:w-1/2 xl:w-1/3`}
    >
      <div className="flex flex-col gap-2">
        <h2 className="text-3xl font-bold text-danger-700">انتبه!</h2>
        <p className="text-danger-700">
          هل أنت متأكد أنك تريد حذف هذا المعدن؟ هذه العملية لا يمكن التراجع
          عنها.
        </p>
      </div>
      <div className="flex gap-4">
        <button
          disabled={inProgress}
          onClick={handleOnConfirmDeleteOpportunity}
          className="flex w-full items-center justify-center gap-2 border-2 border-danger-500 bg-danger-400 px-4 py-2 text-white hover:bg-danger-500 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
        >
          {inProgress ? (
            <>
              <FaSpinner
                size={16}
                className="animate-spin"
              />
              <span>جاري تأكد...</span>
            </>
          ) : (
            <span>تأكد</span>
          )}
        </button>
        <button
          disabled={inProgress}
          onClick={() => onClose()}
          className="disabled={true} w-full border-2 border-muted-500 bg-muted-100 px-4 py-2 hover:bg-muted-500 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
        >
          إلغاء
        </button>
      </div>
    </Modal>
  )
}
